import { USER_ROLE } from '../enum/role.enum';

export const ADMIN_ROUTER = {
  ADMIN_PORTAL: {
    INDEX: 1,
    ROUTER: 'admin-portal',
    ALLOWED_ROLE: USER_ROLE.ADMIN,
  },
  INTERCOM_ACCESS: {
    INDEX: 2,
    ROUTER: 'intercom-access',
    ALLOWED_ROLE: USER_ROLE.SECURITY,
  },
  SUPPORT: {
    INDEX: 3,
    ROUTER: 'support',
    ALLOWED_ROLE: USER_ROLE.FUNCTIONAL_SUPPORT,
  },
  REPORTS: {
    INDEX: 4,
    ROUTER: 'reports',
    ALLOWED_ROLE: USER_ROLE.ADMIN,
  },
  CAR_LICENSE: {
    INDEX: 5,
    ROUTER: 'Car_License',
    ALLOWED_ROLE: USER_ROLE.SECURITY,
  },
  LOG_DOWNLOAD: {
    INDEX: 6,
    ROUTER: 'log-download',
    ALLOWED_ROLE: USER_ROLE.ADMIN,
  }
};

export const APP_ROUTER = {
  ADMIN: 'admin',
  EMPLOYEE: 'employee-portal',
  HELP_LINK: 'help-link',
  CLAIMS: 'claims',
  PARKINGS: 'parkings',
  MESSAGES: 'messages',
  NOTFOUND: 'not-found',
};

export const DEFAULT_ADMIN_PAGE = `admin/${ADMIN_ROUTER.ADMIN_PORTAL.ROUTER}`;
export const DEFAULT_SECURITY_PAGE = `admin/${ADMIN_ROUTER.INTERCOM_ACCESS.ROUTER}`;
export const DEFAULT_SUPPORT_PAGE = `admin/${ADMIN_ROUTER.SUPPORT.ROUTER}`;
export const DEFAULT_CarLicensePlateSearch_PAGE = `admin/${ADMIN_ROUTER.CAR_LICENSE.ROUTER}`;
export const DEFAULT_EMPLOYEE_PAGE = APP_ROUTER.EMPLOYEE;
export const DEFAULT_PARKING_PAGE = APP_ROUTER.PARKINGS;
